import { Stack } from '@mui/material';
import { useTranslation } from 'react-i18next';
import ControlledTextEditor from '../../../../components/custom-inputs/ControlledTextEditor';
import { CaseStudyEditorMenu } from '../../../../components/editor/menu-option-lists/menu-item-lists';

const ContentStep = () => {
  const { t } = useTranslation();
  return (
    <Stack direction="column" spacing={5}>
      <ControlledTextEditor
        label={t('caseStudies.projectGoals')}
        name="description.goals"
        items={CaseStudyEditorMenu}
        required
        key="goals"
      />
      <ControlledTextEditor
        label={t('caseStudies.challenges')}
        name="description.challenges"
        items={CaseStudyEditorMenu}
        required
        key="challenges"
      />
      <ControlledTextEditor
        label={t('caseStudies.solution')}
        name="description.solutions"
        items={CaseStudyEditorMenu}
        required
        key="solutions"
      />
      <ControlledTextEditor
        label={t('caseStudies.results')}
        name="description.results"
        items={CaseStudyEditorMenu}
        required
        key="results"
      />
    </Stack>
  );
};

export default ContentStep;
